import { Injectable } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Params, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { Location } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class QueryParamService {
  public currentQueryParams: Params;
  public uriLabel: string;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private location: Location,
  ) {
    this.currentQueryParams = this.route.snapshot.queryParams;

    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
      if (this.router.routerState.snapshot.url.indexOf('browser') == -1) {
        this.clearQueryParams();
      }
    });
  }

  storeQueryParam(key: string, data: any, history: boolean): void {
    let updatedData: string;
    updatedData = data;
    const updatedQueryParams = { ...this.currentQueryParams, [key]: updatedData };
    //remove params with cleared values
    if (updatedQueryParams) {
      for (const prop in updatedQueryParams) {
        if (updatedQueryParams[prop] === null || updatedQueryParams[prop] === '' || updatedQueryParams[prop] === undefined) {
          delete updatedQueryParams[prop];
        }
      }
    }

    const differenceObj: any = {};
    this.currentQueryParams = this.route.snapshot.queryParams;
    for (const key in updatedQueryParams) {
      if (Object.prototype.hasOwnProperty.call(updatedQueryParams, key)) {
        if (updatedQueryParams[key] !== '') {
          if (this.currentQueryParams[key] !== updatedQueryParams[key]) {
            differenceObj[key] = updatedQueryParams[key];
          }
        }
      }
    }

    const diffParamsLength = Math.abs(Object.keys(this.currentQueryParams).length - Object.keys(updatedQueryParams).length);
    const url = this.router.createUrlTree([], { relativeTo: this.route, queryParams: updatedQueryParams }).toString();

    if (!history) {
      let addToHistory = false;

      if (diffParamsLength > 0) {
        addToHistory = true;
      }

      if (diffParamsLength > 0 || Object.keys(differenceObj).length > 0) {
        let skip = false;
        if (!this.checkNotNullParameter(this.currentQueryParams['currentPage']) && this.checkNotNullParameter(updatedQueryParams['currentPage'])) {
          skip = true;
        }
        if (
          window.location.pathname.includes('mapset-browser') &&
          diffParamsLength === 1 &&
          this.checkNotNullParameter(differenceObj['selectedMapsets']) === true
        ) {
          skip = true;
        }

        if (updatedQueryParams['code'] === 'none') {
          if (
            !this.checkNotNullParameter(this.currentQueryParams['terminology']) &&
            !this.checkNotNullParameter(this.currentQueryParams['publisher']) &&
            !this.checkNotNullParameter(this.currentQueryParams['version']) &&
            !this.checkNotNullParameter(this.currentQueryParams['code']) &&
            this.currentQueryParams['currentPage'] === String(updatedQueryParams['currentPage'])
          ) {
            skip = true;
          }
        } else {
          if (
            !this.checkNotNullParameter(this.currentQueryParams['terminology']) &&
            !this.checkNotNullParameter(this.currentQueryParams['publisher']) &&
            !this.checkNotNullParameter(this.currentQueryParams['version']) &&
            !this.checkNotNullParameter(this.currentQueryParams['code']) &&
            this.checkNotNullParameter(updatedQueryParams['terminology']) &&
            this.checkNotNullParameter(updatedQueryParams['publisher']) &&
            this.checkNotNullParameter(updatedQueryParams['version']) &&
            this.checkNotNullParameter(updatedQueryParams['code']) &&
            this.currentQueryParams['currentPage'] === String(updatedQueryParams['currentPage'])
          ) {
            if (updatedQueryParams['selectedTerminologies'].indexOf(updatedQueryParams['terminology']) > -1 === true) {
              skip = true;
            }
          }
        }

        if (Object.keys(this.currentQueryParams).length === 0 || skip === true) {
          this.router.navigateByUrl(url, { onSameUrlNavigation: 'reload', skipLocationChange: false, replaceUrl: true });
        } else {
          this.router.navigateByUrl(url, { skipLocationChange: false, replaceUrl: false });
        }
      }
      this.currentQueryParams = updatedQueryParams;
    }
  }

  getQueryParam(key: string): any {
    const queryParams = this.route.snapshot.queryParams;
    if (this.currentQueryParams.length === 0) {
      this.currentQueryParams = this.route.snapshot.queryParams;
    }
    if (queryParams[key]) {
      if (key === 'selectedTerminologies' || key === 'selectedMapsets' || key === 'selectedSubsets') {
        return queryParams[key].split(',');
      }

      return queryParams[key];
    }
    return null;
  }

  removeQueryParam(key: string): void {
    const queryParams = { ...this.route.snapshot.queryParams };
    delete queryParams[key];
    const updatedUrlTree = this.router.createUrlTree([], {
      relativeTo: this.route,
      queryParams: queryParams,
    });
    const updatedUrl = this.router.serializeUrl(updatedUrlTree);
    this.location.replaceState(updatedUrl);
  }

  clearQueryParams(): void {
    this.currentQueryParams = [];
  }

  checkNotNullParameter(param: any): boolean {
    let valid = false;
    if (param !== undefined && param !== null && param !== '') {
      if (typeof param !== 'object') {
        valid = true;
      } else {
        if (Object.keys(param).length > 0) {
          valid = true;
        }
      }
    }
    return valid;
  }
}
